import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { overlay } from './Reducers/Overlay.reducer';
import productFiltering from './Reducers/ProductFiltering.reducer';
import { productListing } from './Reducers/ProductListing.reducer';
import { search } from './Reducers/Search.reducer';
import { buyButton } from './Reducers/BuyButton.reducer';
import { login } from './Reducers/Login.reducer';
import userInfoSlice from './Reducers/UserInfo.reducer';
import { priceHistory } from './Reducers/PriceHistory.reducer';
import productPage from './Reducers/ProductPage/ProductPage.reducer';
import CollectionStoreReducer from './Reducers/CollectionStore.reducer';
import QuickOrderReducer from './Reducers/QuickOrder.reducer';
import channelPicker from './Reducers/ChannelPicker.reducer';
import { yotpo } from './Reducers/Yotpo.reducer';
import wishList from './Reducers/WishList.reducer';
import returnForm from './Reducers/ReturnForm.reducer';
import {featureToggling} from "./Reducers/FeatureToggling.reducer";

const staticReducers = {
  cart,
  quickSearch,
  navigation,
  checkout,
  myPage,
  overlay,
  productFiltering,
  productListing,
  search,
  buyButton,
  login,
  userInfo: userInfoSlice,
  priceHistory,
  productPage,
  CollectionStoreReducer,
  channelPicker,
  yotpo,
  QuickOrderReducer,
  wishList,
  returnForm,
  featureToggling,
};

const rootReducer = combineReducers(staticReducers);

export const createReducer = (asyncReducers: any) => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
